module.exports = __webpack_public_path__ + "static/media/Chat-selected.fd928b4b.svg";